import script from "./PriceInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceInfo.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__